/**
 * Resolve logo display mode from whitelabel JSON.
 *
 * logoMode:
 *   - "none"       → şirket logosu yok, default Mole
 *   - "standalone" → sadece şirket logosu (Mole hiç yok)
 *   - "withMole"   → şirket + Mole beraber
 *
 * Legacy: useLogo + logoLayout
 *
 * @returns {"none"|"standalone"|"withMole"}
 */
const getWhitelabelLogoMode = (config) => {
  if (!config || typeof config !== "object") return "none";

  const mode = config.logoMode ?? config.logomode;
  if (mode === "none" || mode === "standalone" || mode === "withMole") {
    return mode;
  }

  // Legacy: useLogo false / missing → none
  if (config.useLogo === false) return "none";

  if (config.useLogo === true) {
    return config.logoLayout === "standalone" ? "standalone" : "withMole";
  }

  // logoLayout alone (without useLogo)
  if (config.logoLayout === "standalone") return "standalone";
  if (config.logoLayout === "withMole") return "withMole";

  return "none";
};

/**
 * Sidenav layout when logoMode is "withMole".
 *   - "footer"     → üstte şirket, altta Mole (default)
 *   - "horizontal" → sidenav header'da yan yana
 *   - "none"       → sidenav'da şirket logosu yok, varsayılan Mole
 *
 * @returns {"footer"|"horizontal"|"none"}
 */
export const getWhitelabelSidenavLogoLayout = (config) => {
  if (!config || typeof config !== "object") return "footer";
  const layout =
    config.sidenavLogoLayout ?? config.sidenavlogolayout ?? config.sidenavLayout;
  if (layout === "horizontal" || layout === "footer" || layout === "none") {
    return layout;
  }
  return "footer";
};

export default getWhitelabelLogoMode;
